// extracted by mini-css-extract-plugin
export var chip = "_35-9";
export var chipLabel = "_35-a";
export var close = "_35-7";
export var closeIcon = "_35-8";
export var error = "_35-6";
export var infoTooltip = "_35-2";
export var innerContainer = "_35-1";
export var input = "_35-b";
export var medium = "_35-5";
export var outerContainer = "_35-0";
export var small = "_35-4";
export var xSmall = "_35-3";